// src/modules/app-views/serviceOrders/components/StatusTag.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tag } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const StatusTag = ({ status, data, style = {} }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const orderStatus = status || data?.status;

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  if (!orderStatus) return null;

  const color = getStatusColor(orderStatus);

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Tag color={color} style={{ margin: 0, ...style }}>
      {translateX(`status_${orderStatus}`)}
    </Tag>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default StatusTag;

// *******************************************************************************
// HELPERS
// *******************************************************************************

/**
 * Returns Ant Design tag color for a given service order status
 * @param {string} status - The status key
 * @returns {string} Ant Design color name
 */
function getStatusColor(status) {
  const colorMap = {
    // Budget statuses
    draft: 'default',
    sent: 'processing',
    approved: 'success',
    rejected: 'error',
    expired: 'warning',
    converted: 'purple',

    // Order statuses
    open: 'processing',
    in_progress: 'cyan',
    waiting_parts: 'warning',
    completed: 'success',
    invoiced: 'geekblue',
    delivered: 'purple',
    canceled: 'error',
  };

  return colorMap[status] || 'default';
}

export { getStatusColor };
